import React, { Component, useEffect } from "react";
import { Routes, Route, useLocation, Outlet } from "react-router-dom";

import DefaultFooter from "../components/Footer/DefaultFooter";
import AuthNavbar from "../components/Navbars/AuthNavbar";

// dinamically create pages routes
import routes from "../PlmRoutes.jsx";
import bgImage from "./../assets/img/full-screen-image-3.jpg";

const AuthLayout: React.FC = () => {

    const location = useLocation();

    useEffect(() => {
        if (document.documentElement.className.indexOf("nav-open") !== -1) {
            document.documentElement.classList.toggle("nav-open");
        }
    }, []);

    function getPageClass() {
        switch (location.pathname) {
            case "/auth/register-page": return " register-page";
            case "/auth/lock-screen-page": return " lock-page";
            default: return " login-page";
        }
    }

    function getRoutes(routes) {
        return routes.map((prop, key) => {
            if (prop.layout === "/auth") {
                return <Route path={prop.layout + prop.path} key={key} >{prop.component}</Route>
            }
            return "";
        });
    };

    return (
        <div>
            <div className="wrapper wrapper-full-page">
                <AuthNavbar />
                <div className={"full-page" + getPageClass()} data-color="black" data-image={bgImage} >
                    <div className="content">
                        <Outlet />
                        <Routes>{getRoutes(routes)}</Routes>
                    </div>
                    <DefaultFooter transparent />
                    <div className="full-page-background" style={{ backgroundImage: "url(" + bgImage + ")" }} />
                </div>
            </div>
        </div>
    );
}
export default AuthLayout;
